module.exports = __webpack_public_path__ + "static/img/核心3.c983272.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/核心3.png
// module id = KPtu
// module chunks = 1